export default {
    BASE_URL: '',
    api: [
        {
            name: 'list',
            desc: '获取入场列表',
            method: 'GET',
            path: '/company/pms/entry/list'
        },
        {
            name: 'searchByCode',
            desc: '根据验证码查询工人',
            method: 'GET',
            path: '/company/pms/entry/online/detail'
        },
        {
            name: 'enter',
            desc: '入场',
            method: 'POST',
            path: '/company/pms/entry/online/add'
        },
        {
            name: 'getTeamListByProjectId',
            desc: '获取班组列表',
            method: 'GET',
            path: '/company/pms/entry/getTeamListByProj'
        },
        {
            name: 'searchByMobile',
            desc: '根据手机号码查询工人',
            method: 'GET',
            path: '/company/pms/entry/builder/{mobile}/{projId}'
        },
        {
            name: 'offlineEnter',
            desc: '线下入场',
            method: 'POST',
            path: '/company/pms/entry/offline/add'
        },
        {
            name: 'quit',
            desc: '退场',
            method: 'PUT',
            path: '/ent/pms/exit/exitProject'
        },
        {
            name: 'complete',
            desc: '设置招聘完成',
            method: 'PUT',
            path: '/company/rms/edit/complete'
        },
        {
            name: 'updateWorker',
            desc: '入场管理编辑工人',
            method: 'PUT',
            path: '/ent/pms/entry/updateWorker'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/project/join.js